import { FornecedorDropDown } from "../../../../../common/domain/models/fornecedor_dropdown";
import { FuncionarioDropDown } from "../../../../../common/domain/models/funcionario_dropdown";
import { ICreateMapaConcretagemUseCase } from "../../../presentation/useCases/create/create_mapa_concretagem_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";
import { UserFriendlyError } from "../../../../../common/utils/base_error";

import dayjs from "dayjs";

/**
 * CreateMapaConcretagemUseCase
 */

export class CreateMapaConcretagemUseCase implements ICreateMapaConcretagemUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async createMapaConcretagem(
    idObra: number,
    dataConcretagem: Date,
    tipoConcreto: string | null,
    slupFlowSolicitado: string | null,
    resistMpa: string | null,
    ensaioConcreto: number | null,
    fornecedor: FornecedorDropDown | string | null,
    nroCarro: string | null,
    nroNotaFiscal: string | null,
    saidaUsina: string | null,
    entradaObra: string | null,
    inicioLancamento: string | null,
    finalLancamento: string | null,
    qteM3: string | null,
    slumpFlowEncontrado: string | null,
    localLancamento: string,
    dataEnvioObra: Date | null,
    laboratorio: FornecedorDropDown | string | null,
    nroCorpoProva: string | null,
    nroLote: string | null,
    instrucaoLancamento: string | null,
    enviadoLaboratorio: boolean | null,
    dataEnviadoLaboratorio: Date | null,
    resistencia12hs: string | null,
    resistencia12hs_checkbox: boolean | null,
    resistencia4: string | null,
    resistencia4_checkbox: boolean | null,
    resistencia7: string | null,
    resistencia7_checkbox: boolean | null,
    resistencia14: string | null,
    resistencia14_checkbox: boolean | null,
    resistencia21: string | null,
    resistencia21_checkbox: boolean | null,
    resistencia28: string | null,
    resistencia28_checkbox: boolean | null,
    resistencia56: string | null,
    resistencia56_checkbox: boolean | null,
    resistencia63: string | null,
    resistencia63_checkbox: boolean | null,
    idade1: string | null,
    resultado1: string | null,
    idade2: string | null,
    resultado2: string | null,
    idade3: string | null,
    resultado3: string | null,
    aprovado: boolean | null,
    dataAprovacao: Date | null,
    responsavelAprovacao: FuncionarioDropDown | string | null,
    observacao: string | null,
    arquivo1: File | null,
    arquivo2: File | null,
    arquivo3: File | null,
    arquivo4: File | null,
    moduloResistenciaGPA: string | null,
    ensaioModuloElasticidade: boolean | null,
    nroLaudo: string | null,
    checkElasticidade28: boolean | null,
    elasticidade28: string | null,
  ): Promise<number> {
    let fornecedorDesc: string | null = null;
    let fornecedorId: number | null = null;

    let laboratorioDesc: string | null = null;
    let laboratorioId: number | null = null;

    let aprovadorDesc: string | null = null;
    let aprovadorId: number | null = null;

    const saidaUsinaTime = this.convertStrTimeToNumber(saidaUsina);
    const entradaObraTime = this.convertStrTimeToNumber(entradaObra);
    const inicioLancamentoTime = this.convertStrTimeToNumber(inicioLancamento);
    const finalLancamentoTime = this.convertStrTimeToNumber(finalLancamento);

    if (fornecedor) {
      if (typeof fornecedor === 'object') {
        fornecedorId = fornecedor.idFornecedor;
      } else if (typeof fornecedor === 'string') {
        fornecedorDesc = fornecedor;
      }
    }

    if (laboratorio) {
      if (typeof laboratorio === 'object') {
        laboratorioId = laboratorio.idFornecedor;
      } else if (typeof laboratorio === 'string') {
        laboratorioDesc = laboratorio;
      }
    }

    if (responsavelAprovacao) {
      if (typeof responsavelAprovacao === 'object') {
        aprovadorId = responsavelAprovacao.idFuncionario;
      } else if (typeof responsavelAprovacao === 'string') {
        aprovadorDesc = responsavelAprovacao;
      }
    }

    if (enviadoLaboratorio) {
      if (!dataEnviadoLaboratorio) {
        throw new UserFriendlyError("O campo Data de envio para o Laboratório deve ser preenchido!");
      }
    }

    if (aprovado) {
      if (!dataAprovacao) {
        throw new UserFriendlyError("O campo Data da Aprovação deve ser preenchido!");
      }
    }

    return await this.repository.createMapaConcretagem(
      idObra,
      dataConcretagem,
      tipoConcreto,
      slupFlowSolicitado,
      resistMpa,
      ensaioConcreto,
      fornecedorId,
      fornecedorDesc,
      nroCarro,
      nroNotaFiscal,
      saidaUsinaTime,
      entradaObraTime,
      inicioLancamentoTime,
      finalLancamentoTime,
      qteM3,
      slumpFlowEncontrado,
      localLancamento,
      dataEnvioObra,
      laboratorioId,
      laboratorioDesc,
      nroCorpoProva,
      nroLote,
      instrucaoLancamento,
      enviadoLaboratorio,
      dataEnviadoLaboratorio,
      resistencia12hs,
      resistencia12hs_checkbox,
      resistencia4,
      resistencia4_checkbox,
      resistencia7,
      resistencia7_checkbox,
      resistencia14,
      resistencia14_checkbox,
      resistencia21,
      resistencia21_checkbox,
      resistencia28,
      resistencia28_checkbox,
      resistencia56,
      resistencia56_checkbox,
      resistencia63,
      resistencia63_checkbox,
      idade1,
      resultado1,
      idade2,
      resultado2,
      idade3,
      resultado3,
      aprovado,
      dataAprovacao,
      aprovadorId,
      aprovadorDesc,
      observacao,
      arquivo1,
      arquivo2,
      arquivo3,
      arquivo4,
      moduloResistenciaGPA,
      ensaioModuloElasticidade,
      nroLaudo,
      checkElasticidade28,
      elasticidade28,
    );
  }

  private convertStrTimeToNumber(str: string | null): number | null {
    if (str === null) return null;
    const arr = str.split(':');
    if (arr === null || arr.length !== 2) return null;
    return dayjs.duration({ hours: Number(arr[0]), minutes: Number(arr[1]) }).asMinutes();
  }
}
